import { EzLandingsTrackerClient } from '.'
import { DATA_TYPE, DATA_VALUE, DATA_EVENT_CLICKABLE, DATA_MISC_JSON } from './constants'

const CLICKABLE_TAG_NAMES = Object.freeze(['A', 'BUTTON', 'SUMMARY'])

const getTrimmedNodeText = (target) => target.textContent.replace(/\s{2,}/g, ' ').trim()

const getMiscJson = (target) => {
  const miscJsonValue = target.getAttribute(DATA_MISC_JSON)

  if (!miscJsonValue || miscJsonValue.charAt(0) !== '{') {
    return {}
  }

  return JSON.parse(miscJsonValue)
}

const handleClickTracker = (event) => {
  const target = event.currentTarget

  if (target.dataset.varsEventClickable === 'false') {
    return
  }

  EzLandingsTrackerClient.trackClick({
    to: target.getAttribute('href'),
    value: target.getAttribute(DATA_VALUE) || getTrimmedNodeText(target),
    type: target.getAttribute(DATA_TYPE),
    miscJson: getMiscJson(target),
  })
}

const elementIterator = (el) => {
  el.addEventListener('click', handleClickTracker)
}

export const setClickEventTracker = () => {
  document.querySelectorAll(`[${DATA_EVENT_CLICKABLE}=true]`).forEach(elementIterator)

  Object.values(CLICKABLE_TAG_NAMES).forEach((tag) => {
    Array.from(document.getElementsByTagName(tag)).forEach(elementIterator)
  })
}
